module.exports = __webpack_public_path__ + "wi-strong-wind.svg";